import React from 'react';

import {
  Grid,
  Typography,
  Chip,
  Hidden,
  Button,
} from '@material-ui/core';

import NextIcon from '@material-ui/icons/ChevronRight';
import PreviousIcon from '@material-ui/icons/ChevronLeft';

import classes from '../../css/getCSS';
import SearchItem from './SearchItem';
import ActiveFilters from './ActiveFilters';


const searchResults = (props) => {
  let results = null;
  if (props.searchResults.results.length > 0) {
    results = props.searchResults.results.map((item) => {
      return (
        // eslint-disable-next-line no-underscore-dangle
        <React.Fragment key={item._source.slug}>
          <SearchItem
            // eslint-disable-next-line no-underscore-dangle
            {...item._source}
          />
        </React.Fragment>
      );
    });
  } else {
    results = (
      <div align="center" className={classes.padding20}>
        <Typography variant="subheading">
          No results found! <br /><br />
          Please modifiy your search criteria to view different results.
        </Typography>
      </div>
    );
  }

  let activeFilters = null;
  if (props.searchResults.active_filters.length > 0) {
    activeFilters = (
      <ActiveFilters
        activeFilters={props.searchResults.active_filters}
        handleRemoveFilter={props.handleRemoveFilter}
      />
    );
  }

  let next = null;
  if (props.searchResults.next) {
    next = (
      <Button
        color="secondary"
        onClick={() => props.paginate(props.searchResults.next)}
        variant="outlined"
      >
        Next
        <NextIcon />
      </Button>
    );
  }

  let previous = null;
  if (props.searchResults.previous) {
    previous = (
      <Button
        color="secondary"
        onClick={() => props.paginate(props.searchResults.previous)}
        variant="outlined"
      >
        <PreviousIcon />
        Previous
      </Button>
    );
  }

  return (
    <React.Fragment>
      <Grid container>
        <Grid item md={6} sm={6} xs={6} style={{ padding: '10px 5px' }}>
          <Typography variant="subheading" className={classes.resultsCountTitle}>{props.searchResults.total} Results Found</Typography>
        </Grid>
        <Grid item md={6} sm={6} xs={6} align="right" style={{ padding: '10px 5px' }}>
          <Chip label="Save Search" clickable onClick={props.saveSearch} />
          <Hidden mdUp>
            <Chip label="Sort / Filter" clickable onClick={props.openMobileFilters} />
          </Hidden>
        </Grid>
      </Grid>
      <div style={{ maxHeight: '200px', overflow: 'auto' }}>
        {activeFilters}
      </div>
      {results}
      <Grid container>
        <Grid item md={6} sm={6} xs={6} className={classes.padding20} align="left">
          {previous}
        </Grid>
        <Grid item md={6} sm={6} xs={6} className={classes.padding20} align="right">
          {next}
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default searchResults;



// WEBPACK FOOTER //
// ./src/search/components/SearchResults.js